const log = {
    invalid_type: '로그 종류가 유효하지 않아요.',
};
export default log;
